var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { attrs: { name: "join-form", width: 0 } }, [
    _c(
      "div",
      { staticClass: "modal modal__sphir_Online_Access_Agreement show" },
      [
        _c(
          "section",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hide,
                expression: "hide"
              }
            ]
          },
          [
            _c("a", { staticClass: "modal__close" }, [
              _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__head" }, [
              _c("h3", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("JOIN.TITLE")) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__body" }, [
              _c("div", { staticClass: "join-agree-content" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("JOIN.P_1")))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("JOIN.P_2")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("JOIN.P_3")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    { staticClass: "join-link", attrs: { href: "/legal" } },
                    [_vm._v(_vm._s(_vm.$t("LINK.LEGAL")))]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("JOIN.P_4")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "join-link",
                      attrs: { href: "/terms_of_use" }
                    },
                    [_vm._v(_vm._s(_vm.$t("LINK.TERM-2")))]
                  ),
                  _vm._v(",\n                        "),
                  _c(
                    "a",
                    {
                      staticClass: "join-link",
                      attrs: { href: "/content_and_behavior_guidelines" }
                    },
                    [_vm._v(_vm._s(_vm.$t("LINK.CAB")))]
                  ),
                  _vm._v(",\n                        "),
                  _c(
                    "a",
                    {
                      staticClass: "join-link",
                      attrs: { href: "/privacy_policy" }
                    },
                    [_vm._v(_vm._s(_vm.$t("LINK.PRIVACY")))]
                  ),
                  _vm._v(",\n                        "),
                  _c(
                    "a",
                    {
                      staticClass: "join-link",
                      attrs: { href: "/card_guidelines" }
                    },
                    [_vm._v(_vm._s(_vm.$t("LINK.GUID")))]
                  ),
                  _vm._v(",\n                        "),
                  _c(
                    "a",
                    {
                      staticClass: "join-link",
                      attrs: { href: "/copyright_and_dmca_policy" }
                    },
                    [_vm._v(_vm._s(_vm.$t("LINK.COPY")))]
                  ),
                  _vm._v(
                    ",\n                        " +
                      _vm._s(_vm.$t("JOIN.P_5")) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("JOIN.P_6")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    { staticClass: "join-link", attrs: { href: "/legal" } },
                    [_vm._v(_vm._s(_vm.$t("LINK.LEGAL")))]
                  ),
                  _vm._v(
                    ",\n                        " +
                      _vm._s(_vm.$t("JOIN.P_7")) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "bullets__filled" }, [
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.LI_1")))]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.LI_2")))]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.LI_3")))]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.LI_4")))]),
                  _vm._v(" "),
                  _c("li", {
                    domProps: { innerHTML: _vm._s(_vm.$t("JOIN.LI_5")) }
                  }),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.LI_6")))]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.LI_7")))])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text__bold margin-b__20" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("JOIN.P_8")) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "bullets__filled" }, [
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.CHECK_1")))]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.CHECK_2")))]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("JOIN.CHECK_3")))])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "margin-b__40" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("JOIN.P_9")) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal__footer text__center margin-t__40" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.localError,
                        expression: "localError"
                      }
                    ],
                    staticClass: "error"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.localError) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "btn btn__round", on: { click: _vm.agree } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("BUTTON.AGREE")) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn__bordered btn__round",
                    on: { click: _vm.disagree }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("BUTTON.DISAGREE")) +
                        "\n                "
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }